(function (ws) {
    'use strict';

    ws.views.quoteFreightCalculationTable = ws.views.simpleTable.extend({
        initialize () {
            this.$table = this.$('#freight-calculation-table');
            this.rowTemplate = this.$('#freight-calculation-table-row');
            this.eventAgg.on('renderFreightTable', this.render.bind(this));
            this.controlColumn = 0;
            this.responsivePriority = [
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1}
            ];
            ws.views.simpleTable.prototype.initialize.call(this);
        },

        /**
         * Render nonFreightDataTable
         * @param {Object} nonFreightData
         */
        render (nonFreightData) {
            if (_.isEmpty(nonFreightData)) {
                this.$el.hide();
                return false;
            }

            this.$el.show();
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            let options;
            const _this = this;
            _.each(nonFreightData, function (row, key) {
                options = {
                    model: {
                        rowId: key,
                        productId: row
                    },
                    rowTemplate: _this.rowTemplate
                };
                const tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();
        }
    });
}(westcon));
